import {gsap} from "gsap";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {SimpleReelModelState, SimpleReelModelSymbolData} from "../../../../core/reel/simplereel/SimpleReelModel";
import {FreespinSymbol} from "../../../reelsfs/FreespinSymbol";
import {DevilsCrossRoadFreespinReel} from "../../../reelsfs/DevilsCrossRoadFreespinReel";
import {DevilsCrossRoadSound} from "../../../sound/DevilsCrossRoadSound";

export class CashGameFeatureHandler {

    public static readonly CG_FEAT_ROW_IDXS: number [][] = [
        [1, 7, 13, 19, 25],
        [2, 8, 14, 20, 26],
        [3, 9, 15, 21, 27],
        [4, 10, 16, 22, 28],
        [5, 11, 17, 23, 29],
    ];

    public static readonly CG_FEAT_COLUMN_IDXS: number [][] = [
        [1, 2, 3, 4, 5],
        [7, 8, 9, 10, 11],
        [13, 14, 15, 16, 17],
        [19, 20, 21, 22, 23],
        [25, 26, 27, 28, 29],
    ];

    private _activeTopFeaturesThisRound: number [] = [];
    private _activeRightFeaturesThisRound: number [] = [];
    private _totalMultiplierGainedFromFeature: number = 0;

    constructor() {
    }

    public resetActiveFeatureList():void {
        this._activeTopFeaturesThisRound.length = 0;
        this._activeRightFeaturesThisRound.length = 0;
    }

    public getTopEyeTimeline(featureId:string, alignmentIndex:number, targetPosition?:number, valuesForUpdate?: number [][]):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const featureTotalIndex: number = alignmentIndex;
        const stickyCoins: string [][] = DevilsCrossRoad.model.stickyCoins;
        let isGoat:boolean = false;

        CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[alignmentIndex].forEach((convId, symIndex) => {
            if((stickyCoins[alignmentIndex][symIndex + 1] !== "C" && stickyCoins[alignmentIndex][symIndex + 1] !== "CX" )) {
                isGoat = true;
            }
        });

        /*
            F1: Adder
            F2: Multiplier
            F3: Bonus Collect
            F4: Copier
            F5: Stealer
            F6: Sharer
        */

        switch(featureId) {
            case "F1":
                const rowUpdateValue: number = DevilsCrossRoad.model.featureClientValueMappedToIndex[featureTotalIndex];


                tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("top", alignmentIndex, "f1"));
                tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("top", alignmentIndex, "f1", rowUpdateValue.toString()),()=>{
                    this.playFeatureOneSound(rowUpdateValue);
                }], "<0.5");
                tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("top", alignmentIndex, "f1", rowUpdateValue.toString()));

                break;
            case "F2":
                if(targetPosition) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("top", alignmentIndex, "f2"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("top", alignmentIndex, "f2"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F2})
                        }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("top", alignmentIndex, "f2"));
                }

                break;
            case "F3":
                tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("top", alignmentIndex, "f3"));
                tl.add([
                    DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("top", alignmentIndex, "f3"),
                    () => {
                     DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_FEATURE_REVEAL_F3});
                    }
                ], "<0.5");
                tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("top", alignmentIndex, "f3"));

                break;
            case "F4":

                if(targetPosition) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("top", alignmentIndex, "f4"));
                    tl.add([
                        DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("top", alignmentIndex, "f4"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F4})
                        }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("top", alignmentIndex, "f4"));
                }

                break;
            case "F5":
                if(targetPosition) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("top", alignmentIndex, "f5"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("top", alignmentIndex, "f5"),
                    () => {
                        DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F5})
                    }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("top", alignmentIndex, "f5"));
                }

                break;
            case "F6":
                if(targetPosition) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("top", alignmentIndex, "f6"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("top", alignmentIndex, "f6"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F6})
                        }], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("top", alignmentIndex, "f6"));
                }

                break;
        }

        // Logic operations
        tl.add(() => {
            if(this._activeTopFeaturesThisRound.indexOf(alignmentIndex) < 0) {
                this._activeTopFeaturesThisRound.push(alignmentIndex);
            }
        },">0.1");

        return tl;
    }

    public getTopEndTimeline(alignmentIndex:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const stickyCoins: string [][] = DevilsCrossRoad.model.stickyCoins;
        let isGoat:boolean = false;
        CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[alignmentIndex].forEach((convId, symIndex) => {
            if((stickyCoins[alignmentIndex][symIndex + 1] !== "C" && stickyCoins[alignmentIndex][symIndex + 1] !== "CX" )) {
                isGoat = true;
            }
        });

        if(this._activeTopFeaturesThisRound.indexOf(alignmentIndex) > -1) {
            tl.add(DevilsCrossRoad.freespinUnlockAreas.playAfterFeatureRun("top", alignmentIndex, isGoat), ">");
            DevilsCrossRoad.freespinReelAreaView.reels.forEach((reels) => {
                reels.forEach((reel) => {
                    tl.add(() => {
                        reel.stopHighlightLoop();
                    });
                });
            });
            tl.add(() => {
                const index = this._activeTopFeaturesThisRound.indexOf(alignmentIndex, 0);
                if (index > -1) {
                    this._activeTopFeaturesThisRound.splice(index, 1);
                }
            });
        }

        return tl;
    }

    public getRightEndTimeline(alignmentIndex:number, isGoat:boolean = false):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();


        if(this._activeRightFeaturesThisRound.indexOf(alignmentIndex) > -1) {
            tl.add(DevilsCrossRoad.freespinUnlockAreas.playAfterFeatureRun("right", alignmentIndex, isGoat), ">");
            DevilsCrossRoad.freespinReelAreaView.reels.forEach((reels) => {
                reels.forEach((reel) => {
                    tl.add(() => {
                        reel.stopHighlightLoop();
                    });
                });
            });
            tl.add(() => {
                const index = this._activeRightFeaturesThisRound.indexOf(alignmentIndex, 0);
                if (index > -1) {
                    this._activeRightFeaturesThisRound.splice(index, 1);
                }
            });
        }

        return tl;
    }

    public playRightResultTimeline(featureId:string, alignmentIndex:number, rowValuesUpdateTo: number [] = [], targetPositionY:number  = -1, targetPositionX:number = -1): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const stickyCoins: string [][] = DevilsCrossRoad.model.stickyCoins;
        let isGoat:boolean = false;

        const myArray: string [][] = stickyCoins;
        const myClonedArray:string [][] = Object.assign([], myArray);
        const flattenedResult = myClonedArray.reduce((accumulator, value) => accumulator.concat(value), []);

        CashGameFeatureHandler.CG_FEAT_ROW_IDXS[alignmentIndex].forEach((convId, symIndex) => {
            if((flattenedResult[convId] !== "C" && flattenedResult[convId] !== "CX")) {
                isGoat = true;
            }
        });


        switch(featureId) {
            case "F1":
                tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                tl.add(() => {
                    DevilsCrossRoad.freespinUnlockAreas.playHorzEffect(alignmentIndex);
                }, 0.5);
                CashGameFeatureHandler.CG_FEAT_ROW_IDXS[alignmentIndex].forEach((flatId, iterIdx) => {
                    tl.add([
                        () => {
                            if(DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.state === SimpleReelModelState.STICKY) {
                                DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            }
                        }
                    ], 0.7);

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);
                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                            let currentVal: number = sym.getValue();
                            let diff: number = rowValuesUpdateTo[iterIdx] - currentVal

                            if (diff > 0) {
                                this._totalMultiplierGainedFromFeature += diff;
                            }
                        },

                        (sym && rowValuesUpdateTo[iterIdx] > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[iterIdx], false, true) : () => {}
                    ], 1.5);
                });
                tl.add(()=>{
                    this.playCoinSelectSound();
                },0.7);
                tl.add(()=>{
                    this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature);
                },1.5);

                tl.add(this.getRightEndTimeline(alignmentIndex, isGoat), ">");
                break;

            case "F2":

                if(targetPositionX > -1) {
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playHorzEffect(alignmentIndex);
                    }, 0.5);

                    const flatId:number = CashGameFeatureHandler.CG_FEAT_ROW_IDXS[alignmentIndex][targetPositionX];

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            this.playCoinSelectSound();
                    }
                    ], 0.7);

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);

                    tl.add((sym && rowValuesUpdateTo[targetPositionX] !== sym.getValue() && rowValuesUpdateTo[targetPositionX] > 0 && sym.getValue() > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[targetPositionX], false, true) : () => {}, 1.5);

                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    }, 1.5/*"<"*/);
                    tl.add(() => {
                        if(sym){
                            this._totalMultiplierGainedFromFeature = sym.getValue();
                        }
                        this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature);
                    }, 1.5);

                    tl.add(this.getRightEndTimeline(alignmentIndex, isGoat), ">");
                }
                break;

            case "F4":
                if(targetPositionX > -1) {
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playHorzEffect(alignmentIndex);
                    });

                    const flatId:number = CashGameFeatureHandler.CG_FEAT_ROW_IDXS[alignmentIndex][targetPositionX];
                    let indexOfCopyCoin:number = -1;
                    let originSym: FreespinSymbol | undefined;
                    let originID:number = -1;

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend(true);
                            this.playCoinSelectSound();
                        }
                    ], 0.4);
                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);

                    const myCoinValueArray:  number [][] = DevilsCrossRoad.model.data.stickyCoinsValues;
                    const myClonedCoinValueArray:number [][] = Object.assign([], myCoinValueArray);
                    const flattenedCoinValueResult = myClonedCoinValueArray.reduce((accumulator, value) => accumulator.concat(value), []);
                    let originSymCopy: FreespinSymbol | undefined;

                    flattenedCoinValueResult.forEach((value, index) => {
                        originID = flatId;

                        // TODO: Get another coin with same value
                        if(indexOfCopyCoin < 0 && index !== originID && value === rowValuesUpdateTo[targetPositionX]) {
                            //indexOfCopyCoin = index;

                            const copyOrigin: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(index).model.getVisibleSymbolAt(0);
                            originSymCopy = (<FreespinSymbol>copyOrigin?.positionable);
                            if(originSymCopy.valueInt === rowValuesUpdateTo[targetPositionX]) {
                                indexOfCopyCoin = index;
                                //console.log("COPY COIN VALUE: " + originSymCopy.getValue());
                                //console.log("COPY COIN INDEX: " + indexOfCopyCoin)
                            }
                        }
                    })


                    if(indexOfCopyCoin > -1) {
                        const symbolDataCopyOrigin: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(indexOfCopyCoin).model.getVisibleSymbolAt(0);
                        originSym = (<FreespinSymbol>symbolDataCopyOrigin?.positionable);
                    }

                    const played:boolean = (sym && rowValuesUpdateTo[targetPositionX] !== sym.getValue() && rowValuesUpdateTo[targetPositionX] > 0 && sym.getValue() > 0);

                    if(originSym) {
                        tl.add(originSym.blinkAndUpdateValue(0, true), 0.9)
                    }

                    tl.add((sym && rowValuesUpdateTo[targetPositionX] !== sym.getValue() && rowValuesUpdateTo[targetPositionX] > 0 && sym.getValue() > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[targetPositionX], false, true) : () => {}, 1.5);

                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    }, 1.5/*"<"*/);

                    if(!played) {
                        tl.add(DevilsCrossRoad.freespinMpView.getRandomMissAnimation());
                    }else{
                        if(sym){
                            tl.add(()=>{this._totalMultiplierGainedFromFeature=rowValuesUpdateTo[targetPositionY - 1]-sym.getValue()});
                            tl.add(()=>{this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature)},1.5);
                        }
                    }
                    tl.add(this.getRightEndTimeline(alignmentIndex, isGoat), ">");
                }
                break;
            case "F5":

                if(targetPositionY > -1 && targetPositionX > -1) {
                    const flatId:number = CashGameFeatureHandler.CG_FEAT_ROW_IDXS[alignmentIndex][targetPositionX];
                    let originID: number = -1;
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playHorzEffect(alignmentIndex);
                    }, 0.5);

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            this.playCoinSelectSound();
                        }
                    ], 0.7);

                    let played:boolean = false;
                    CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[targetPositionX].forEach((index, symIndex) => {
                        originID = flatId;

                        if(index !== originID && rowValuesUpdateTo[symIndex] > 0) {
                            tl.add(DevilsCrossRoad.freespinReelAreaView.playCoinToAnimation(new PIXI.Point(index, 0), new PIXI.Point(originID, 0), index).play(), 1);
                            played = true;
                        }
                    });

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);

                    tl.add(()=>{this._totalMultiplierGainedFromFeature+=rowValuesUpdateTo[targetPositionY - 1]-sym.getValue()});
                    tl.add((sym && rowValuesUpdateTo[targetPositionY - 1] > 0 && sym.getValue() > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[targetPositionY - 1], false, true) :
                    sym.blinkAndUpdateValue(0, true), 1.5);


                    tl.add(() => {
                        this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature);
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    }, 1.5/*"<"*/);

                    if(!played) {
                        tl.add(DevilsCrossRoad.freespinMpView.getRandomMissAnimation());
                    }

                    tl.add(this.getRightEndTimeline(alignmentIndex, isGoat), ">");
                }

                break;
            case "F6":

                if(targetPositionX > -1 && targetPositionY > -1) {

                    const flatId:number = CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[targetPositionX][targetPositionY - 1];
                    let originID: number = -1;
                    const reel: DevilsCrossRoadFreespinReel = DevilsCrossRoad.freespinReelAreaView.getReel(flatId);

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData.positionable);
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playHorzEffect(alignmentIndex);
                    }, 0.5);

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend(true);
                            this.playCoinSelectSound();
                        }
                    ], 0.7);

                    tl.add((sym)? sym.blinkAndUpdateValue(sym.getValue(), true, true) : () => {
                    }, 1.5);

                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    });


                    let played:boolean = false;
                    CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[targetPositionX].forEach((index, symIndex) => {
                        const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(index).model.getVisibleSymbolAt(0);
                        let sym: FreespinSymbol = (<FreespinSymbol>symbolData.positionable);
                        originID = flatId;

                        if(index !== originID && rowValuesUpdateTo[symIndex] > 0) {
                            tl.add(()=>{this._totalMultiplierGainedFromFeature+= rowValuesUpdateTo[symIndex] - sym.getValue()});
                            tl.add(DevilsCrossRoad.freespinReelAreaView.playCoinToAnimation(new PIXI.Point(originID, 0), new PIXI.Point(index, 0), originID).play());
                            tl.add(sym.blinkAndUpdateValue(rowValuesUpdateTo[symIndex], false, true));
                            played = true;
                        }
                    });

                    tl.add(()=>{this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature)},">");
                    if(!played) {
                       tl.add(DevilsCrossRoad.freespinMpView.getRandomMissAnimation());
                    }

                    tl.add(this.getRightEndTimeline(alignmentIndex, isGoat), ">");
                    tl.add(() => {
                        //debugger;
                        reel.stopHighlightLoop();
                    });
                }

                break;
        }

        tl.add(() => {
            if(this._activeRightFeaturesThisRound.indexOf(alignmentIndex) < 0) {
                this._activeRightFeaturesThisRound.push(alignmentIndex);
            }
        });

        return tl;
    }

    public playTopResultTimeline(featureId:string, alignmentIndex:number, rowValuesUpdateTo: number [] = [], targetPositionY = -1, targetPositionX = -1): gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const stickyCoins: string [][] = DevilsCrossRoad.model.stickyCoins;
        let isGoat:boolean = false;
        CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[alignmentIndex].forEach((convId, symIndex) => {
            if((stickyCoins[alignmentIndex][symIndex + 1] !== "C" && stickyCoins[alignmentIndex][symIndex + 1] !== "CX")) {
                isGoat = true;
            }
        });

        switch(featureId) {
            case "F1":
                tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                tl.add(() => {
                    DevilsCrossRoad.freespinUnlockAreas.playVertEffect(alignmentIndex);
                }, 0.5);
                CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[alignmentIndex].forEach((flatId, iterIdx) => {
                    tl.add([
                        () => {
                            if(DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.state === SimpleReelModelState.STICKY) {
                                DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            }
                        }
                    ], 0.7);

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);
                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                            let currentVal: number = sym.getValue();
                            let diff: number = rowValuesUpdateTo[iterIdx] - currentVal

                            if (diff > 0) {
                                this._totalMultiplierGainedFromFeature += diff;
                            }
                            },
                        (sym && rowValuesUpdateTo[iterIdx] > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[iterIdx], false, true) : () => {}
                    ], 1.5);
                });
                tl.add(() => {
                    this.playCoinSelectSound();
                }, 0.7);
                tl.add(()=>{
                 this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature);
                },1.5);
                tl.add(this.getTopEndTimeline(alignmentIndex), ">");
                break;
            case "F2":
                if(targetPositionY > -1) {
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playVertEffect(alignmentIndex);
                    }, 0.5);
                    const flatId:number = CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[alignmentIndex][targetPositionY - 1];

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            this.playCoinSelectSound();
                        }
                    ], 0.7);
                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);

                    tl.add((sym && rowValuesUpdateTo[targetPositionY -1] !== sym.getValue() && rowValuesUpdateTo[targetPositionY - 1] > 0 && sym.getValue() > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[targetPositionY - 1], false, true) : () => {}, 1.5);

                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    }, 1.5/*"<"*/);
                    tl.add(() => {
                        if(sym){
                            this._totalMultiplierGainedFromFeature = sym.getValue();
                        }
                        this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature);
                    }, 1.5);
                    tl.add(this.getTopEndTimeline(alignmentIndex), ">");
                }
                break;
            case "F3":

                tl.add(() => {
                    DevilsCrossRoad.freespinCollectorView.updateCollect(DevilsCrossRoad.model.data.collectMeter);
                });

                tl.add(this.getTopEndTimeline(alignmentIndex), ">");
                break;
            case "F4":

                if(targetPositionY > -1) {
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playVertEffect(alignmentIndex);
                    });
                    const flatId:number = CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[alignmentIndex][targetPositionY - 1];
                    let indexOfCopyCoin:number = -1;
                    let originSym: FreespinSymbol | undefined;
                    let originID:number = -1;

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend(true);
                            this.playCoinSelectSound();
                        }
                    ], 0.4);
                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);

                    const myCoinValueArray:  number [][] = DevilsCrossRoad.model.data.stickyCoinsValues;
                    const myClonedCoinValueArray:number [][] = Object.assign([], myCoinValueArray);
                    const flattenedCoinValueResult = myClonedCoinValueArray.reduce((accumulator, value) => accumulator.concat(value), []);

                    let originSymCopy: FreespinSymbol | undefined;
                    flattenedCoinValueResult.forEach((value, index) => {
                        originID = flatId;

                        // Get another coin with same value already updated on client reel
                        if(indexOfCopyCoin < 0 && index !== originID && value === rowValuesUpdateTo[targetPositionY - 1]) {
                            const copyOrigin: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(index).model.getVisibleSymbolAt(0);
                            originSymCopy = (<FreespinSymbol>copyOrigin?.positionable);
                            if(originSymCopy.valueInt === rowValuesUpdateTo[targetPositionY - 1]) {
                                indexOfCopyCoin = index;
                                //console.log("COPY COIN VALUE: " + originSymCopy.getValue());
                                //console.log("COPY COIN INDEX: " + indexOfCopyCoin)
                            }
                        }
                    })


                    if(indexOfCopyCoin > -1) {
                        const symbolDataCopyOrigin: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(indexOfCopyCoin).model.getVisibleSymbolAt(0);
                        originSym = (<FreespinSymbol>symbolDataCopyOrigin?.positionable);
                    }

                    const played:boolean = (sym && rowValuesUpdateTo[targetPositionY - 1] !== sym.getValue() && rowValuesUpdateTo[targetPositionY - 1] > 0 && sym.getValue() > 0);

                    if(originSym) {
                        tl.add(originSym.blinkAndUpdateValue(0, true), 0.9);
                    }
                    tl.add((sym && rowValuesUpdateTo[targetPositionY - 1] !== sym.getValue() && rowValuesUpdateTo[targetPositionY - 1] > 0 && sym.getValue() > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[targetPositionY - 1], false, true) : () => {}, 1.5);

                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    }, 1.5/*"<"*/);
                    if(played){
                        if(sym){
                            tl.add(()=>{this._totalMultiplierGainedFromFeature=rowValuesUpdateTo[targetPositionY - 1]-sym.getValue()});
                            tl.add(()=>{this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature)},1.5);
                        }
                    }

                    if(!played) {
                        tl.add(DevilsCrossRoad.freespinMpView.getRandomMissAnimation());
                    }

                    tl.add(this.getTopEndTimeline(alignmentIndex), ">");
                }
                break;
            case "F5":

                if(targetPositionX > -1) {

                    const flatId:number = CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[targetPositionX][targetPositionY - 1];
                    let originID: number = -1;
                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playVertEffect(alignmentIndex);
                    }, 0.5);

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            this.playCoinSelectSound();
                        }
                    ], 0.7);

                    let played:boolean = false;
                    CashGameFeatureHandler.CG_FEAT_ROW_IDXS[targetPositionY - 1].forEach((index, symIndex) => {
                        originID = flatId;

                        if(index !== originID && rowValuesUpdateTo[symIndex] > 0) {
                            tl.add(DevilsCrossRoad.freespinReelAreaView.playCoinToAnimation(new PIXI.Point(index, 0), new PIXI.Point(originID, 0), index).play(), 1);
                            played = true;
                        }
                    });

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData?.positionable);

                    if (rowValuesUpdateTo[targetPositionX] > 0) {
                        tl.add(()=>{this._totalMultiplierGainedFromFeature+=rowValuesUpdateTo[targetPositionX]-sym.getValue()});
                        tl.add((sym && rowValuesUpdateTo[targetPositionX] > 0 && sym.getValue() > 0) ? sym.blinkAndUpdateValue(rowValuesUpdateTo[targetPositionX], false, true) : () => {
                        }, 1.5);
                    } else {
                        tl.add((sym) ? sym.blinkAndUpdateValue(0, true) : () => {
                        }, 1.5);
                    }
                    tl.add(()=>{this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature)},1.5);
                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    }, 1.5/*"<"*/);

                    if(!played) {
                        tl.add(DevilsCrossRoad.freespinMpView.getRandomMissAnimation());
                    }

                    tl.add(this.getTopEndTimeline(alignmentIndex), ">");
                }

                break;
            case "F6":
                if(targetPositionX > -1 && targetPositionY > -1) {
                    const flatId:number = CashGameFeatureHandler.CG_FEAT_COLUMN_IDXS[targetPositionX][targetPositionY - 1];
                    let originID: number = -1;

                    const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(flatId).model.getVisibleSymbolAt(0);
                    let sym: FreespinSymbol = (<FreespinSymbol>symbolData.positionable);

                    tl.add(()=>{this._totalMultiplierGainedFromFeature=0; },0);
                    tl.add(() => {
                        DevilsCrossRoad.freespinUnlockAreas.playVertEffect(alignmentIndex);
                    }, 0.5);

                    tl.add([
                        () => {
                            DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend();
                            this.playCoinSelectSound();
                        }
                    ], 0.7);


                    tl.add((sym)? sym.blinkAndUpdateValue(sym.getValue(), true, true) : () => {
                    }, 1.5);

                    tl.add(() => {
                        DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlight();
                    });

                    tl.add([
                        () => {DevilsCrossRoad.freespinReelAreaView.getReel(flatId).playHighlightAndPend(true)}
                    ], 0.7);

                    let played:boolean = false;
                    CashGameFeatureHandler.CG_FEAT_ROW_IDXS[targetPositionY - 1].forEach((index, symIndex) => {
                        const symbolData: SimpleReelModelSymbolData = DevilsCrossRoad.freespinReelAreaView.getReel(index).model.getVisibleSymbolAt(0);
                        let sym: FreespinSymbol = (<FreespinSymbol>symbolData.positionable);
                        originID = flatId;

                        if(index !== originID && rowValuesUpdateTo[symIndex] > 0) {
                            tl.add(()=>{this._totalMultiplierGainedFromFeature+= rowValuesUpdateTo[symIndex] - sym.getValue()});
                            tl.add(DevilsCrossRoad.freespinReelAreaView.playCoinToAnimation(new PIXI.Point(originID, 0), new PIXI.Point(index, 0), originID).play());
                            tl.add(sym.blinkAndUpdateValue(rowValuesUpdateTo[symIndex], false, true));
                            played = true;
                        }
                    });
                    tl.add(()=>{this.playCoinUpdateSound(this._totalMultiplierGainedFromFeature)},">");


                    if(!played) {
                        tl.add(DevilsCrossRoad.freespinMpView.getRandomMissAnimation());
                    }
                    tl.add(this.getTopEndTimeline(alignmentIndex), ">");
                    tl.add(() => {DevilsCrossRoad.freespinReelAreaView.getReel(flatId).stopHighlightLoop()});
                }

                break;
        }

        tl.add(() => {
            if(this._activeTopFeaturesThisRound.indexOf(alignmentIndex) < 0) {
                this._activeTopFeaturesThisRound.push(alignmentIndex);
            }
        });


        return tl;
    }

    public getRightEyeTimeline(featureId:string, alignmentIndex:number, targetPosition?:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        const featureTotalIndex: number = 5 + alignmentIndex;

        switch(featureId) {
            case "F1":
                const rowUpdateValue: number = DevilsCrossRoad.model.featureClientValueMappedToIndex[featureTotalIndex];

                tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("right", alignmentIndex, "f1"));
                tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("right", alignmentIndex, "f1", rowUpdateValue.toString()),()=>{
                    this.playFeatureOneSound(rowUpdateValue);
                }], "<0.5");
                tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("right", alignmentIndex, "f1", rowUpdateValue.toString()));
                break;
            case "F2":
                if(targetPosition && targetPosition > -1) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("right", alignmentIndex, "f2"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("right", alignmentIndex, "f2"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F2})
                        }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("right", alignmentIndex, "f2"));
                }

                break;
            case "F4":
                if(targetPosition && targetPosition > -1) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("right", alignmentIndex, "f4"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("right", alignmentIndex, "f4"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F4})
                        }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("right", alignmentIndex, "f4"));
                }
                break;
            case "F5":
                if(targetPosition && targetPosition > -1) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("right", alignmentIndex, "f5"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("right", alignmentIndex, "f5"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F5})
                        }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("right", alignmentIndex, "f5"));
                }
                break;
            case "F6":
                if(targetPosition) {

                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeature("right", alignmentIndex, "f6"));
                    tl.add([DevilsCrossRoad.freespinUnlockAreas.playFeatureInEye("right", alignmentIndex, "f6"),
                        () => {
                            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_FEATURE_REVEAL_F6})
                        }
                    ], "<0.5");
                    tl.add(DevilsCrossRoad.freespinUnlockAreas.playEyeFeatureIdle("right", alignmentIndex, "f6"));
                }
                break;
        }

        tl.add(() => {
            if(this._activeRightFeaturesThisRound.indexOf(alignmentIndex) < 0) {
                this._activeRightFeaturesThisRound.push(alignmentIndex);
            }
        },">0.1");

        return tl;
    }

    private playCoinSelectSound(): void {
        if (!DevilsCrossRoadSound.soundPlayer.fetchSoundPlayer(DevilsCrossRoadSound.FS_COIN_SELECT)?.isPlaying) {
            DevilsCrossRoadSound.soundPlayer.playTrack({name: DevilsCrossRoadSound.FS_COIN_SELECT});
        }

    }

    private playFeatureOneSound(featureAmount: number): void {
        let soundNo: string = "";
        if (featureAmount === 1 || featureAmount === 2 || featureAmount === 3) {
            soundNo = "fsFeatureRevealGluttony1";
        } else if (featureAmount === 5 || featureAmount === 10) {
            soundNo = "fsFeatureRevealGluttony2";
        } else if (featureAmount === 20 || featureAmount === 50) {
            soundNo = "fsFeatureRevealGluttony3";
        } else if (featureAmount === 100) {
            soundNo = "fsFeatureRevealGluttony4";
        }
        DevilsCrossRoadSound.soundPlayer.playTrack({name: soundNo});
    }

    private playCoinUpdateSound(valueGained: number): void {
        let soundNo: number = 0;
        if (valueGained <= 5) {
            soundNo = 0;
        } else if (valueGained >= 6 && valueGained <= 15) {
            soundNo = 1;
        } else if (valueGained >= 16 && valueGained <= 30) {
            soundNo = 2;
        } else if (valueGained > 30) {
            soundNo = 3;
        }
        DevilsCrossRoadSound.soundPlayer.playTrack({name:DevilsCrossRoadSound.FS_COIN_UPDATE[soundNo]});
    }
}